import { AfterViewInit, Component, OnInit } from '@angular/core';

import { JwtAuthService } from './shared/services/auth/jwt-auth.service';
import { AmplitudeService } from './shared/services/amplitude.service';
import { PersonMessagesEntityService } from './state/entity-services/person-messages-entity.service';
import { environment } from '../environments/environment';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'patient';
  growUpImage = false;
  showApp: boolean = environment.disableAnimationIntro;

  constructor(
    private router: Router,
    private personMessagesEntityService: PersonMessagesEntityService,
    private amplitudeService: AmplitudeService,
    private jwtAuthService: JwtAuthService) {
    this.growUpImage = false;

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((): void => {
        setTimeout(() => {
          document.getElementById('main-content')?.scrollTo(0, 0);
        }, 0);
      });

    if (jwtAuthService.isLoggedIn) {
      this.personMessagesEntityService.checkJobEvents().subscribe({
        next: data => {
          console.info(data);
        }
      });
    }
  }

  ngOnInit() {
    try {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault(); // Block auto banner install
        // (window as any).deferredPrompt = e;
      });
    } catch (e) {
      console.error(e);
    }
  }


  ngAfterViewInit() {
    this.amplitudeService.init(this.jwtAuthService.getUser());
    this.amplitudeService.setIdentify(this.jwtAuthService.getUser());
    this.jwtAuthService.setUserSentry();


    if (this.showApp) { // ANIMATION DISABLED
      document.getElementById('APP_LOADER').remove();
      return;
    }

    setTimeout(() => {
      this.growUpImage = true;

      setTimeout(() => {
        document.getElementById('APP_LOADER').remove();
      }, 300);

      setTimeout(() => {
        this.showApp = true;
      }, 900);

    }, 3000);

  }
}

